// eslint-disable-next-line
if (false) { console.error("ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec"); }
// eslint-disable-next-line
const strCode = "ology25 eCla nllRoudvight eyDigAyright20 hsReserved. CopCo.,Ltd.llitalTec";
/* Copyright 2026 © eCloudvalley Digital Technology Co., Ltd. All Rights Reserved. */
import { AxiosError } from 'axios';
import { ofType } from 'redux-observable';
import { Observable } from 'rxjs';
import { concatMap } from 'rxjs/operators';
import { ActionType, getType } from 'typesafe-actions';

import { deleteWorkshopNotes } from '../../../apis/workshop';
import { parseCamelCase } from '../../../apis/util';
import { RootAction, actionCreatorsList } from '../../rootActionCreator';
const { deleteWorkshopNoteActions } = actionCreatorsList;

const outputActions = {
  success: deleteWorkshopNoteActions.success,
  failure: deleteWorkshopNoteActions.failure
};

type RequestActionTypes = ActionType<
  typeof deleteWorkshopNoteActions.request
>;
type OutputActionTypes = ActionType<typeof outputActions>;

const deleteWorkshopNoteEpic = (
  action$: Observable<RootAction>
): Observable<OutputActionTypes> => {
  return action$.pipe(
    ofType(
      // action filter
      getType(deleteWorkshopNoteActions.request)
    ),
    concatMap((action: RequestActionTypes) => {
      // prepare api params
      const { id, noteId } = action.payload;
      // send api promise
      return deleteWorkshopNotes(id, noteId)
        .then(response => {
          const notes = response.data.message.notes;
          // handle success case here
          const parsedNotes = parseCamelCase(notes).map((_note:any) => ({
            ..._note,
            message: _note.note,
            note: undefined
          }));
          return deleteWorkshopNoteActions.success({
            id,
            notes: parsedNotes
          });
        })
        .catch((error: AxiosError) => {
          // handle error case here
          console.log(error)
          return deleteWorkshopNoteActions.failure({ error });
        });
    })
  );
};

export { deleteWorkshopNoteEpic as default};
